import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Button } from 'reactstrap'

import { fetchAnything, openError, startLoading, stopLoading } from 'containers/App/reducers'
import { getStatusCodesAndErrorCode, trimData } from 'utils/commonFunctions'

import Header from '../components/Header'
import { postCreateBooking, putUpdateBooking, patchUpdateBookingStatus } from '../api'
import PrevStartButton from '../components/PrevStartButton'
import { clearAll } from '../reducers'
import DriverConfirmations from '../components/DriverConfirmations'
import { buildBooking } from '../services'
import PageNumber from '../components/PageNumber'
import {
  STATUS_CHECKIN_TIME_NOT_FOUND,
  STATUS_CHECKIN_TIME_BOOKING_NOT_FOUND,
  HEADER_HEIGHT,
} from '../constants'
import AlertModal from 'components/AlertModal'
import { DEFAULT_OTHER_OPTION_SELECT } from 'components/SelectOptions'
import theme from 'vars/theme'
import { isSp } from '../utils'
import { SpFrame } from '../components/SpFrame'
import StartFromBeginningButton from '../components/StartFromBeginningButton'
import SpFooter from '../components/SpFooter'
class EntryConfirmationPage extends Component {
  state = {
    confirmedIds: [],
    isOpenModalSubmitError: false,
    messageSubmitError: '',
    isSp: isSp(),
  }

  componentDidMount() {
    const { match, returnEntryPage, history } = this.props
    const {
      params: { warehouseId, tenantId },
    } = match

    if (returnEntryPage) {
      history.push(`/receipt-booking/${warehouseId}/${tenantId}`)
    }

    window.addEventListener('resize', this.handleResize)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
  }

  handleResize = () => {
    this.setState({ isSp: isSp() })
  }

  onChangeCheck = (e, confirmation) => {
    const { confirmedIds } = this.state
    const { checked } = e.target
    const newConfirmedIds = checked
      ? confirmedIds.concat(confirmation.id)
      : confirmedIds.filter((confirmedId) => confirmedId !== confirmation.id)
    this.setState({ confirmedIds: newConfirmedIds })
  }

  resetIfDefault = (value, isBooking) =>
    value === DEFAULT_OTHER_OPTION_SELECT
      ? ''
      : isBooking
        ? this.props.booking.driverMinutes
        : value

  onClickConfirm = async () => {
    const { history, match, booking, driver, currentTenant } = this.props
    let { driverDate, driverHours, driverMinutes, entryInstructionTime, ...restBooking } = booking

    driverDate = this.resetIfDefault(driverDate)
    driverHours = this.resetIfDefault(driverHours)
    driverMinutes = this.resetIfDefault(driverMinutes, true)

    const { confirmedIds } = this.state
    const {
      params: { warehouseId, tenantId },
    } = match
    let methodNotification

    const formattedEntryTime =
      driverDate && driverHours && driverMinutes
        ? `${driverDate} ${driverHours}:${driverMinutes}`
        : entryInstructionTime
    const updatedBooking = { ...restBooking, entryInstructionTime: formattedEntryTime }
    const data = buildBooking(
      { ...updatedBooking, confirmations: confirmedIds },
      warehouseId,
      tenantId,
      driver.driverPhone
    )

    if (data.repeatId) {
      data.applyType = 2
    }

    this.props.startLoading()

    try {
      const trimmedData = trimData(data)

      if (data.bookingNo) {
        const resp = await putUpdateBooking(trimmedData)
        const result = await patchUpdateBookingStatus({
          ...trimmedData,
          bookingId: resp?.data?.booking_id,
        })
        methodNotification = {
          lineFlag: result?.line_flag,
          portalFlag: result?.portal_flag,
          isCheckedPhone: driver?.phoneChecked,
        }
      } else {
        const resp = await postCreateBooking(trimmedData)
        methodNotification = {
          lineFlag: resp?.data?.line_flag,
          portalFlag: resp?.data?.portal_flag,
          isCheckedPhone: driver?.phoneChecked,
        }
      }
    } catch (error) {
      const { errors } = error?.data || {}
      const checkinTimeNotFound = errors?.find(
        (error) => error?.code === STATUS_CHECKIN_TIME_NOT_FOUND
      )
      const checkinTimeBookingNotFound = errors?.find(
        (error) => error?.code === STATUS_CHECKIN_TIME_BOOKING_NOT_FOUND
      )
      if (checkinTimeNotFound) {
        this.setState({ isOpenModalSubmitError: true })
        this.setState({ messageSubmitError: checkinTimeNotFound?.message })
        return
      }
      if (checkinTimeBookingNotFound) {
        this.setState({ isOpenModalSubmitError: true })
        this.setState({ messageSubmitError: checkinTimeBookingNotFound?.message })
        return
      }
      const { errorCodes, status } = getStatusCodesAndErrorCode(error)
      this.props.openError(error.message, true, errorCodes, status)
      return
    } finally {
      this.props.stopLoading()
    }

    this.props.clearAll()

    history.push({
      pathname: `/receipt-booking/entry-finish/${warehouseId}/${tenantId}`,
      state: {
        canUnmannedCheckin: currentTenant?.canUnmannedCheckin,
        methodNotification,
      },
    })
  }

  onClickCheck = (confirmation) => {
    if (confirmation?.checkFlag) {
      const { confirmedIds } = this.state
      const isUnCheck = confirmedIds?.includes(confirmation?.id)
      const newConfirmedIds = isUnCheck
        ? confirmedIds?.filter((confirmedId) => confirmedId !== confirmation?.id)
        : confirmedIds?.concat(confirmation?.id)
      this.setState({ confirmedIds: newConfirmedIds })
    }
  }

  handleClickRedirectCheckinPage = () => {
    const { history, match } = this.props
    const {
      params: { warehouseId, tenantId },
    } = match

    history.push(`/receipt-booking/${warehouseId}/${tenantId}`)
    this.setState({ isOpenModalSubmitError: false })
  }

  render() {
    const { match, driverConfirmations, driver, history } = this.props
    const {
      params: { warehouseId, tenantId },
    } = match
    const { confirmedIds, isOpenModalSubmitError, messageSubmitError } = this.state
    const requiredConfirmations = driverConfirmations.filter(
      (confirmation) => confirmation.checkFlag
    )

    if (this.state.isSp) {
      return (
        <div style={{ backgroundColor: theme.graySoft6, minHeight: '100vh', fontSize: 18 }}>
          <Header isSp driver={driver} />

          <div
            className="p-4"
            style={{ overflowY: 'auto', height: `calc(100vh - ${HEADER_HEIGHT})` }}
          >
            <div style={{ marginBottom: 10 }}>
              <StartFromBeginningButton
                onClick={() => history.push(`/receipt-booking/${warehouseId}/${tenantId}`)}
              />
            </div>

            <SpFrame title="ドライバーの皆様へ">
              <DriverConfirmations
                isSp
                isCheckinPage
                confirmations={driverConfirmations}
                confirmedIds={confirmedIds}
                onChangeCheck={this.onChangeCheck}
                onClickCheck={this.onClickCheck}
              />
            </SpFrame>

            <div className="mt-4">
              <SpFooter
                onBackClick={() =>
                  history.push(`/receipt-booking/entry-load/${warehouseId}/${tenantId}`)
                }
                onNextClick={
                  confirmedIds.length === requiredConfirmations.length
                    ? this.onClickConfirm
                    : undefined
                }
                nextButtonCaption="登録完了"
              />
            </div>
          </div>

          <AlertModal
            isOpen={isOpenModalSubmitError}
            title={messageSubmitError}
            textOk="OK"
            handleConfirm={this.handleClickRedirectCheckinPage}
            width={window.innerWidth - 20 /* margin in each side */}
          />
        </div>
      )
    }

    return (
      <div
        style={{ backgroundColor: theme.graySoft1, height: '100vh', fontSize: 18, minWidth: 1024 }}
      >
        <Header driver={driver} />
        <div style={{ margin: 32 }}>
          <div
            className="bg-white mb-3 p-3"
            style={{ borderRadius: 12, maxHeight: 'calc(100vh - 300px)', overflow: 'auto' }}
          >
            <DriverConfirmations
              isCheckinPage
              confirmations={driverConfirmations}
              confirmedIds={confirmedIds}
              onChangeCheck={this.onChangeCheck}
              onClickCheck={this.onClickCheck}
            />
          </div>

          <div className="d-flex justify-content-between">
            <div style={{ width: '33%' }}>
              <PrevStartButton
                to={`/receipt-booking/${warehouseId}/${tenantId}`}
                data-dg-id="entry-confirmation-page-prev-start-button"
              />
            </div>
            <div className="text-center" style={{ width: '34%' }}>
              <PageNumber
                page="entry-confirmation"
                existsDriverConfirmations={Boolean(driverConfirmations.length)}
                isFreePlan={!driver.tenant.canBerthBook}
              />
            </div>
            <div className="text-right" style={{ width: '33%' }}>
              <Button
                outline
                color="primary"
                className="rounded-pill bg-white px-4 mr-3 text-primary"
                onClick={() =>
                  history.push(`/receipt-booking/entry-load/${warehouseId}/${tenantId}`)
                }
              >
                もどる
              </Button>
              <Button
                color="primary"
                className="rounded-pill px-4"
                onClick={this.onClickConfirm}
                disabled={confirmedIds.length !== requiredConfirmations.length}
              >
                確認して受付完了
              </Button>
            </div>
          </div>
        </div>

        <AlertModal
          isOpen={isOpenModalSubmitError}
          title={messageSubmitError}
          textOk="OK"
          handleConfirm={this.handleClickRedirectCheckinPage}
        />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const reception = state.get('reception')
  return {
    driverConfirmations: reception.driverConfirmations,
    booking: reception.booking,
    driver: reception.driver,
    currentTenant: reception?.driver?.tenant,
    returnEntryPage: reception.returnEntryPage,
  }
}

const mapDispatchToProps = {
  fetchAnything,
  openError,
  startLoading,
  stopLoading,
  clearAll,
}

export default connect(mapStateToProps, mapDispatchToProps)(EntryConfirmationPage)
